import React from "react";
import { useParams } from "react-router-dom";

import AuthHeader from "../../components/dashboard/authHeader";
import Single from '../../components/dashboard/posts/singlePost';

function DashboardSinglePost() {

  const { id } = useParams();

  return (
    <>
      <AuthHeader />
      <Single id={id} />
    </>
  );
}

export default DashboardSinglePost;